"use strict";
'use es6';
/**
 * Returns true if `value` is an Object.
 * 
 * @param {any} value
 * @return {boolean}
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function isObject(value) {
  return (0, _typeof2.default)(value) === 'object' && value !== null;
}

module.exports = exports.default;